(function () {
  if (window.collectionCardsReady) return;
  window.collectionCardsReady = true;

  function init(root) {
    if (!root || root.dataset.cardsReady === 'true') return;
    root.dataset.cardsReady = 'true';

    var track = root.querySelector('[data-cards-track]');
    var prev = root.querySelector('[data-cards-prev]');
    var next = root.querySelector('[data-cards-next]');
    var toggle = root.querySelector('[data-cards-toggle]');
    if (!track) return;

    function resetScroll() {
      var behavior = track.style.scrollBehavior;
      track.style.scrollBehavior = 'auto';
      track.scrollLeft = 0;
      track.style.scrollBehavior = behavior;
    }

    function step() {
      var item = track.querySelector('.collection-cards__item');
      if (!item) return track.clientWidth;
      var gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
      return item.getBoundingClientRect().width + gap;
    }

    function update() {
      if (!prev || !next) return;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }

    resetScroll();

    if (document.readyState === 'complete') {
      update();
    } else {
      window.addEventListener('load', function () {
        resetScroll();
        update();
      });
    }

    if (prev && next) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });

      next.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });

      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    }

    if (toggle) {
      toggle.addEventListener('click', function () {
        var expanded = root.classList.toggle('is-expanded');
        toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');

        if (!expanded) {
          resetScroll();
          update();

          var header = document.querySelector('.site-header');
          var offset = header ? header.getBoundingClientRect().height + 16 : 100;
          var top = root.getBoundingClientRect().top + window.pageYOffset - offset;
          window.scrollTo({ top: top, behavior: 'smooth' });
        }
      });
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-collection-cards]').forEach(init);
  }

  initAll();

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();